import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/shared/PageHeader';
import { SettingsForm } from '@/components/features/settings/SettingsForm';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { LoadingState } from '@/components/shared/LoadingState';
import { ErrorState } from '@/components/shared/ErrorState';
import { useSettings } from '@/lib/hooks';
import { AlertCircle } from 'lucide-react';

export const Route = createFileRoute('/_auth/_admin/admin/settings/')({
  component: SettingsComponent,
});

function SettingsComponent() {
  const { isLoading, isError, error } = useSettings();

  if (isLoading) {
    return <LoadingState />;
  }

  if (isError) {
    return <ErrorState title={error.name} message={error.message} />;
  }

  return (
    <div className="space-y-6">
      <PageHeader
        title="Настройки сайта"
        description=""
      />

      <Alert>
        <AlertCircle className="h-4 w-4" />
        <AlertDescription>
            Изменения в этих настройках немедленно повлияют на работу системы. Пожалуйста, внимательно ознакомьтесь с ними перед сохранением.
        </AlertDescription>
      </Alert>

      <Card>
        <CardHeader>
          <CardTitle>Настройки системы</CardTitle>
        </CardHeader>
        <CardContent>
          <SettingsForm />
        </CardContent>
      </Card>
    </div>
  );
}
